module.exports = __webpack_public_path__ + "logos/logo-komodor.f81111.svg";